import { ColorEnum } from '@/constants/color'
import Badge from '@/features/ui/components/Badge'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'

interface TitleAndBadgeProps {
    title: string
    badge: string
}

const TitleAndBadge: FC<TitleAndBadgeProps> = ({ title, badge }) => {
    return (
        <View style={styles.container}>
            <Typography.Description font="medium" numberOfLines={1} style={styles.title}>
                {title}
            </Typography.Description>
            <Badge size="small" style={styles.badge}>
                {badge}
            </Badge>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
    },
    title: {
        flexShrink: 1,
        color: ColorEnum.JET_900,
    },
    badge: {
        marginLeft: 4,
    },
})

export default TitleAndBadge
